import type React from 'react';
import { Typography } from '@heroui/react';
import { cn, getNodeTestIdProp } from '@/utils';
import type { DiffKind } from '../shiftMeta';

export type ShiftFigureRowProps = {
    label: string;
    /** The figure, already formatted for display. */
    value: string;
    /** Marks the figure as a match or a difference; plain when absent. */
    diffKind?: DiffKind;
    testId: string;
};

/** One labelled cash figure in a shift summary. Render-only. */
export const ShiftFigureRow: React.FC<ShiftFigureRowProps> = ({
    label,
    value,
    diffKind,
    testId,
}) => (
    <div className="flex items-center justify-between">
        <Typography color="muted" type="body-sm">
            {label}
        </Typography>
        <Typography
            className={cn(
                diffKind &&
                    (diffKind === 'match' ? 'text-success' : 'text-danger'),
                'tabular-nums',
            )}
            {...getNodeTestIdProp(testId)}
            type="body-sm"
            weight={diffKind ? 'semibold' : undefined}
        >
            {value}
        </Typography>
    </div>
);
